
import { useNavigate } from 'react-router-dom';

import '../styles/EmployeeMaster.css';
import DeptCategoryTable from '../components/DeptCategoryTable';

const DeptCategory = () => {
  const navigate = useNavigate();

  const handleAddClick = () => {
    
    navigate('/deptcategory/add');
  };

  

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Dept Category Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Dept Category
        </button>
      </div>

      <DeptCategoryTable />
    </div>
  );
};

export default DeptCategory